import React from 'react'
import logoRPC from '../assets/logo-rpc.png'
import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: 50,
    backgroundColor: '#1B6494',
    zIndex: 999,
  },

  // marginTop: 16,
  logo: {
    height: 52,
  },
}))

const BannerRPC = () => {
  const classes = useStyles()

  return (
    <Grid container justify='center' className={classes.root}>
      <img className={classes.logo} alt={'Logo da RPC'} src={logoRPC} />
    </Grid>
  )
}

export default BannerRPC
